import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Button, CardContent } from '@design-system-coopeuch/web';
import { encuestaActions } from '../../../../application/actions/encuesta';
import btnCerrar from '../../../assets/img/icon/btn-cerrar.svg';
import { WrapperModalEncuestaSatisfaccion } from './styles';
import Pregunta1 from '../../molecules/PreguntasEncuestaSatisfaccion/Pregunta1';
import Pregunta2 from '../../molecules/PreguntasEncuestaSatisfaccion/Pregunta2';
import { Encuesta } from '../../../../utils/Encuesta';
import { codigoAplicacion } from '../../../../utils/index';

const ModalEncuestaSatisfaccion = ({
  setTipoRespuesta,
  setOpenModalEncuestaSatisfaccion,
  setOpenModalRespuestaEncuesta,
  setEncuestaRespondida,
}) => {
  const [cantidadPreguntas] = useState(2);
  const [preguntaActual, setPreguntaActual] = useState(1);
  const [loading, setLoading] = useState(false);
  const [botonDisabled, setBotonDisabled] = useState(true);
  const [calificacionEstrella, setCalificacionEstrella] = useState(0);
  const [calificacionSmiley, setCalificacionSmiley] = useState(0);
  const [respuestaTextoPregunta1, setRespuestaTextoPregunta1] = useState('');
  const [respuestaTextoPregunta2, setRespuestaTextoPregunta2] = useState('');
  const [indicesOpcionesPorPregunta] = useState({
    pregunta1: 1,
    pregunta2: 8,
  });
  const [request, setRequest] = useState([]);

  const storeDataEncuesta = useSelector((store) => store.entities.encuesta.response);

  const dispatch = useDispatch();

  const enviar = () => {
    const respuesta =
      preguntaActual !== cantidadPreguntas
        ? {
            idPregunta: Encuesta.satisfaccion.preguntas[0].idPregunta,
            respuestas: [
              {
                idOpcion: calificacionEstrella + (indicesOpcionesPorPregunta.pregunta1 - 1),
                comentario: respuestaTextoPregunta1,
              },
            ],
          }
        : {
            idPregunta: Encuesta.satisfaccion.preguntas[1].idPregunta,
            respuestas: [
              {
                idOpcion: calificacionSmiley + (indicesOpcionesPorPregunta.pregunta2 - 1),
                comentario: respuestaTextoPregunta2,
              },
            ],
          };
    const requestAux = {
      codigoAplicacion,
      codigoEncuesta: Encuesta.satisfaccion.codigo,
      preguntas: [],
    };
    requestAux.preguntas = [...request];
    requestAux.preguntas.push(respuesta);
    setRequest(requestAux.preguntas);
    setPreguntaActual(preguntaActual + 1);
    if (preguntaActual === cantidadPreguntas) {
      dispatch(encuestaActions.encuesta(requestAux));
      setEncuestaRespondida(true);
      setLoading(true);
    }
  };

  useEffect(() => {
    if ('code' in storeDataEncuesta) {
      setBotonDisabled(false);
      setOpenModalEncuestaSatisfaccion(false);
      setOpenModalRespuestaEncuesta(true);
    }
    const { code } = storeDataEncuesta;

    if (code === 0) {
      setTipoRespuesta('exito');
    } else {
      setTipoRespuesta('error');
    }
  }, [storeDataEncuesta]);

  return (
    <WrapperModalEncuestaSatisfaccion>
      {!loading && (
        <div className="modal">
          <div className="modal-content">
            <Card>
              <CardContent className="tituloModal">
                <div className="barraTop">
                  <Button variant="text" onClick={() => setOpenModalEncuestaSatisfaccion(false)}>
                    <img src={btnCerrar} alt="close" />
                  </Button>
                </div>
                {preguntaActual === 1 && (
                  <Pregunta1
                    setBotonDisabled={setBotonDisabled}
                    calificacionEstrella={calificacionEstrella}
                    setCalificacionEstrella={setCalificacionEstrella}
                    respuestaTexto={respuestaTextoPregunta1}
                    setRespuestaTexto={setRespuestaTextoPregunta1}
                  />
                )}
                {preguntaActual === 2 && (
                  <Pregunta2
                    setBotonDisabled={setBotonDisabled}
                    calificacionSmiley={calificacionSmiley}
                    setCalificacionSmiley={setCalificacionSmiley}
                    respuestaTexto={respuestaTextoPregunta2}
                    setRespuestaTexto={setRespuestaTextoPregunta2}
                  />
                )}
              </CardContent>
              <CardContent className="cardSiguiente">
                <div className="siguiente">
                  {preguntaActual === cantidadPreguntas ? (
                    <Button
                      className="botonTerminar"
                      variant="outline"
                      onClick={() => enviar()}
                      disabled={botonDisabled}
                    >
                      Enviar y terminar
                    </Button>
                  ) : (
                    <Button
                      className="botonContinuar"
                      variant="text"
                      onClick={() => enviar()}
                      disabled={botonDisabled}
                    >
                      Enviar y continuar
                    </Button>
                  )}
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
      )}
    </WrapperModalEncuestaSatisfaccion>
  );
};
ModalEncuestaSatisfaccion.propTypes = {
  setTipoRespuesta: PropTypes.func.isRequired,
  setOpenModalEncuestaSatisfaccion: PropTypes.func.isRequired,
  setOpenModalRespuestaEncuesta: PropTypes.func.isRequired,
  setEncuestaRespondida: PropTypes.func.isRequired,
};

export default ModalEncuestaSatisfaccion;
